import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularSvgIconModule, SvgIconRegistryService } from 'angular-svg-icon';
import { Subscription, take, tap } from 'rxjs';

import { IconService } from './icon.service';
import { AppIcon, AppIconColor, AppIconSize } from '../frontend-icons.interfraces';

@Component({
  selector: 'tr-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class IconComponent implements OnInit, OnChanges, OnDestroy {
  @Input() icon: AppIcon;
  @Input() size = AppIconSize.regular;
  @Input() white = false;
  @Input() color: AppIconColor;
  @Input() classes: string;
  @Input() disabled = false;
  styles: Record<string, string> | null = null;
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly service: IconService,
    private readonly cdr: ChangeDetectorRef,
    private readonly svgIconRegistry: SvgIconRegistryService,
  ) { }

  ngOnInit(): void {
    const changeIconColorSubscription = this.service.darkIcons$
      .pipe(tap(() => {
        this.generateStyles();
      }))
      .subscribe();
    this.subscriptions.add(changeIconColorSubscription);
  }

  ngOnChanges(): void {
    this.generateStyles();
    this.markForCheckOnSvgLoad();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  generateStyles(): void {
    let fill = this.white || !this.service.darkIcons ? '#fff' : '#4B5574';

    if (this.color !== undefined) {
      fill = this.color;
    }

    if (this.disabled) {
      fill = 'rgb(180, 180, 180)';
    }

    this.styles = {
      fill,
      'width.px': this.size,
      'height.px': this.size,
    };
  }

  private markForCheckOnSvgLoad(): void {
    if (!this.icon) return;
    const obs = this.svgIconRegistry.loadSvg(`assets/icons/${this.icon}.svg`);
    if (!obs) return;
    const sub = obs.pipe(take(1)).subscribe(() => this.cdr.markForCheck());
    this.subscriptions.add(sub);
  }
}
